import * as React from "react"
import PropTypes from "prop-types"
import { ThemeProvider } from "@material-ui/core/styles"

import Header from "../Header"
import theme from "../Theme"
import "./style.css"
import Nav from "../Nav"
import Footer from "../Footer"

const Layout = ({ children }) => {
  return (
    <ThemeProvider theme={theme}>
      <Header />
      <div>
        <Nav />
        <main>{children}</main>
        <Footer />
      </div>
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
}

export default Layout
